<template>
  <div class="my-3">
    <l-map
      ref="map"
      :zoom.sync="map.zoom"
      :center.sync="map.center"
      :options="map.options"
      style="height: 70vh"
    >
      <l-tile-layer :url="$t('map.tiles')" :attribution="map.attribution" />
      <l-marker
        v-for="(reference, index) in referencesWithLocation"
        :key="'marker-' + index"
        :lat-lng="convert(reference.location.coordinates.lat, reference.location.coordinates.lon)"
      >
        <l-popup>
          <b-card class="border-0" :title="reference.title ? reference.title[$i18n.locale] : null" :sub-title="reference.customerName">
            <b-row>
              <b-col>
                <b-badge
                  v-for="family in reference.productFamily"
                  :key="family"
                  class="m-1"
                  :class="{ [family.toLowerCase()]: true }"
                >{{ family }}</b-badge>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-button
                  size="sm"
                  variant="link"
                  :to="{ name: 'reference', params: {id: reference.id} }"
                >{{ $t('map.goToReference') }}</b-button>
              </b-col>
            </b-row>
          </b-card>
        </l-popup>
      </l-marker>
    </l-map>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import { latLng, latLngBounds } from "leaflet";

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  data: () => ({
    map: {
      zoom: null,
      center: null,
      options: {
        zoomSnap: 0.5,
      },
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(47.41322, -1.219482),
      withTooltip: latLng(47.41422, -1.250482),
    },
  }),
  computed: {
    ...mapState("references", ["references", "totalCount", "loading"]),
    referencesWithLocation() {
      return (this.references || []).filter(
        (r) => r.location?.coordinates != null
      );
    },
  },
  methods: {
    ...mapMutations("references", ["setFetchParams"]),
    ...mapActions("references", ["fetchReferences"]),
    convert(lat, lng) {
      return latLng(lat, lng);
    },
  },
  watch: {
    references(value) {
      if (value) {
        const bounds = [null, null, null, null];
        this.referencesWithLocation.forEach((ref) => {
          const coords = ref.location.coordinates;
          if (bounds[0] == null || coords.lat > bounds[0])
            bounds[0] = coords.lat;
          if (bounds[1] == null || coords.lat < bounds[1])
            bounds[1] = coords.lat;
          if (bounds[2] == null || coords.lon > bounds[2])
            bounds[2] = coords.lon;
          if (bounds[3] == null || coords.lon < bounds[3])
            bounds[3] = coords.lon;
        });
        const [maxLat, minLat, maxLon, minLon] = bounds;
        setTimeout(() => {
          if (this.referencesWithLocation.length > 0) {
            this.$refs.map.mapObject.fitBounds(
              latLngBounds(latLng(minLat, minLon), latLng(maxLat, maxLon)),
              { padding: [50, 50] }
            );
            if (maxLat == minLat && maxLon == minLon) {
              this.map.zoom = 11;
            }
          }
          this.$refs.map.mapObject.invalidateSize();
        }, 100);
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.setFetchParams({
        offset: 0,
        limit: null,
      });
      vm.fetchReferences();
    });
  },
};
</script>